import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";
import { useState } from "react";

import { Button } from "@/components/ui/button/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/dropdown-menu";
import { LeaveApplication } from "./schema";
import { useTakeActionModal } from "../take-action-modal/use-action-modal";
import { useViewModal } from "../view-leave-application-modal/use-view-modal";

import { useAuth } from "@/lib/use-auth";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as LeaveApplication;
  const { data: authData } = useAuth();

  const [open, setOpen] = useState(false);

  const { onOpenChange, setLeaveId } = useTakeActionModal();
  const { onOpenChange: onViewModalChange, setLeaveApplication } =
    useViewModal();

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
        >
          <DotsHorizontalIcon className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        {authData?.user?.permissions?.["2"]?.includes("LeaveApplication") && (
          <DropdownMenuItem
            onMouseDown={() => {
              setLeaveId(originData?.id);
              onOpenChange(true);
              setOpen(false);
            }}
          >
            Take Action
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onMouseDown={() => {
            setLeaveApplication(originData);
            onViewModalChange(true);
            setOpen(false);
          }}
        >
          View
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
